/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { PeriodType } from '@/api/gql/graphql';
import { useGetFinance, useGetFinanceSummary } from '@/api/hooks/useFinance';
import { useGetFinanceAnalytic } from '@/api/hooks/useFinanceAnalytic';
import { ColumnDefinition } from '@/components/Ui/DataTable/DataTable.type';
import { useFinanceStore } from '@/store/FinanceStore/FinanceStore';
import { useFilterStore } from '@/store/useFilterOptionsStore';
import { useMemo } from 'react';

const columns: ColumnDefinition[] = [
  { field: 'parrain', header: 'Parrain' },
  { field: 'montant', header: 'Montant' },
  { field: 'qualite', header: 'Qualité' },
  { field: 'paymentMode', header: 'Mode de paiement' },
  { field: 'date', header: 'Date' },
];

export enum Status {
  PENDING = 'PENDING',
  INVALID = 'INVALID',
  OK = 'OK',
}

const TransactionStatus = [
  { _id: 1, name: 'PENDING' },
  { _id: 2, name: 'OK' },
  { _id: 3, name: 'INVALID' },
];

export const statusConfig: Record<Status, { label: string; color: string }> = {
  [Status.PENDING]: { label: 'En attente', color: 'text-pending' },
  [Status.INVALID]: { label: 'Invalide', color: 'text-completed' },
  [Status.OK]: { label: 'Validé', color: 'text-running' },
};

export const useFinance = () => {
  const { data: financeSummary, isLoading: loadingFinanceSummary } =
    useGetFinanceSummary();

  const {
    filter,
    setFilter,
    financeListLimit,
    setFinanceListLimit,
    financeListPage,
    setFinanceListPage,
  } = useFinanceStore();
  const { data: transactions, isPending: loadingFinance } = useGetFinance({
    status: filter,
    limit: financeListLimit,
    page: financeListPage,
  });
  const { filterSelections, setIsOpenFilter } = useFilterStore();

  const transactionList = transactions?.data?.map((item: any) => {
    const date = new Date(item.createdAt);
    const formattedDate = date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    const list = {
      id: item?._id,
      client: `${item?.user.firstName} ${item?.user.lastName}`,
      phoneNumber: item?.user.phoneNumber,
      subscription: item.subscription_packages_ref?.description ?? 'N/A',
      price: item?.price ?? 0,

      paymentMode: item.payment_method ?? 'N/A',
      status: item.status,
      date: formattedDate ?? 'N/A',
    };
    return list;
  });

  const handleFilters = (value: any) => {
    setFilter(value.name);
  };

  const processedFinanceSummary = useMemo(() => {
    return financeSummary
      ?.map((item) => {
        return {
          title: item.name,
          value: item?.totalTransactions,
          totalAmountPending: item?.totalAmountPending,
          totalAmount: item?.totalAmount,
        };
      })
      .filter(
        (item) =>
          item.title.includes('trimestriel') ||
          item.title.includes('annuel') ||
          item.title.includes('mensuel'),
      );
  }, [financeSummary]);

  return {
    financeSummary: processedFinanceSummary,
    columns,
    transactionList,
    transactions,
    handleFilters,
    TransactionStatus,
    loadingFinanceSummary,
    loadingFinance,
    financeListLimit,
    setFinanceListLimit,
    setFinanceListPage,
    financeListPage,
    statusConfig,
    filterSelections,
    setIsOpenFilter,
  };
};
